import React, { Suspense, ReactElement, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { etatUtilisateurConnecte } from '../../State';
import Navbar from './Navbar';
import Footer from './Footer';
import './Vitrine.scss';
import LoadingScreen from '../Common/LoadingScreen';
import HeroSlider from '../Common/HeroSlider';
import NousJoindre from './NousJoindre/NousJoindre';
import TawkToChat from '../Dashboard/messengerChat';

// Dynamic imports for route components
const Activites = React.lazy(() => import('./Activites/Index'));
const NotFound = React.lazy(() => import('../NotFound'));
const FormReservation = React.lazy(() => import('./Reservation/Reservation'));
const Home = React.lazy(() => import('../Home'));
const Transport = React.lazy(() => import('../Transport'));
const Login = React.lazy(() => import('../Authentification/Login'));
const Guide = React.lazy(() => import('./Activites/Activite/Guide'));
const RecuperationMDP = React.lazy(() => import('../Authentification/RecuperationMDP'));
const ModificationMDP = React.lazy(() => import('../Authentification/ModificiationMDP'));
const Avis = React.lazy(() => import('./Avis'));
const AfficherPDF = React.lazy(() => import('./Activites/PDF/AfficherPDF'));
const CreerCompte = React.lazy(() => import('../Authentification/CreerCompte'));
const Profile = React.lazy(() => import('../Authentification/Profile'));
const PageRechercheVitrine = React.lazy(() => import('./BarreRechercheVitrine/PageRechercheVitrine'));

export default function Vitrine(): ReactElement {
    const [utilisateurConnecte] = useRecoilState(etatUtilisateurConnecte);
    const [affichageActivitePublic, setAffichageActivitePublic] = useState<boolean>(
        localStorage.getItem('modePublic') === 'true',
    );

    const [faqSelectedItem, setFaqSelectedItem] = useState<string | null>(null);

    const goTo = (where: string) => {
        const yOffset = -10;
        const element = document.getElementById(where);
        if (element) {
            const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    const openPolitique = () => {
        setFaqSelectedItem('4');
        setTimeout(() => {
            goTo('section-4');
        }, 300);
    };

    useEffect(() => {
        localStorage.setItem('modePublic', `${affichageActivitePublic}`);
    }, [affichageActivitePublic]);

    const location = useLocation();

    return (
        <div className="vitrine d-flex flex-column">
            <Navbar
                affichageActivitePublic={affichageActivitePublic}
                setAffichageActivitePublic={setAffichageActivitePublic}
                onOpenPolitique={openPolitique}
                onGoToFaq={() => goTo('FAQ')}
            />
            {location.pathname === '/' && <HeroSlider />}

            <Container fluid className="main-container container-vitrine flex-grow-1">
                <Avis />
                <Routes>
                    <Route
                        path="/"
                        element={
                            <Home affichageActivitePublic={affichageActivitePublic} faqSelectedItem={faqSelectedItem} />
                        }
                    />
                    <Route path="/transport" element={<Transport />} />
                    <Route
                        path="activites/*"
                        element={<Activites affichageActivitePublic={affichageActivitePublic} />}
                    />
                    <Route path="activites/:id" element={<Guide />} />
                    <Route path="activites/:id/pdf" element={<AfficherPDF />} />
                    <Route path="reservation" element={<FormReservation />} />
                    <Route path="*" element={<NotFound />} />
                    <Route path="login" element={<Login />} />
                    <Route path="creerCompte" element={<CreerCompte />} />
                    <Route path="recuperationMotDePasse" element={<RecuperationMDP />} />
                    {utilisateurConnecte.connecte || utilisateurConnecte.mettreAJourMotDePasse ? (
                        <Route path="miseajourmotdepasse" element={<ModificationMDP />} />
                    ) : null}
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/nousjoindre" element={<NousJoindre />} />
                    <Route
                        path="/recherche"
                        element={<PageRechercheVitrine toggleEstPublic={affichageActivitePublic} />}
                    />
                </Routes>
            </Container>
            <div style={{ position: 'absolute', bottom: '20px', right: '20px' }}>
                <Suspense fallback={<LoadingScreen />}>
                    <TawkToChat />
                </Suspense>
            </div>
            <Footer />
        </div>
    );
}
